module.exports = __webpack_public_path__ + "static/media/CityDunkTeaser.22648762.jpg";